'use strict';
angular.module('editingCenterSignedRouterModule', []).config(['$stateProvider',
    function($stateProvider) {
        $stateProvider.state('front.editctr.app.signed', {
            url: '/signed?siteid&channelid&hasChildren',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/app/signed/main_tpl.html',
                    controller: 'editCompileSignedCtroller'
                }
            }
        }).state('front.editctr.app.signed.focus', {
            url: '/focus',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/app/signed/focus/main_focus_tpl.html',
                // controller:'editCompileSignedFocusController'
                }
            }
        }).state('front.editctr.app.signed.retraction', {
            url: '/retraction',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/app/signed/retraction/main_retraction_tpl.html',
                    controller: 'editCompileSignedRetractionCtroller'
                }
            }
        });
    }
]);
